module.exports = __webpack_public_path__ + "static/media/5.0548d746.jpg";